import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { AnalyticsProvider, AnalyticsTrigger, Button, Card, CardContent, Grid, GridColumn, Icon, Separator, useCurrentBreakPoint } from 'telia-front-react';
import { useStores } from '../stores/RootStore';
import { FetchStatus } from '../util/FetchStatus';

export interface ServiceNotificationProps {
  text: string;
  ctaText: string;
  icon: string;
  ctaUrl: string;
  productType?: string;
}

const ServiceNotification = observer((props: ServiceNotificationProps) => {
  const { text, ctaText, ctaUrl, icon, productType } = props;
  const { productStore, ssoStore } = useStores();
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === 'xs' || currentBreak === 'sm';
  const numberOfServices = productType === 'TV' ? productStore.numberOfTvServices : productStore.numberOfHomeInternetServices;
  const status = productType === 'TV' ? productStore.numberOfTvServicesFetchStatus : productStore.numberOfHomeInternetServicesFetchStatus;

  useEffect(() => {
    productType === 'TV' ? productStore.fetchNumberOfTvServices() : productStore.fetchNumberOfHomeInternetServices();
  }, [ssoStore.customerId, productType]);

  if (!numberOfServices || status !== FetchStatus.FETCHED) {
    return null;
  }

  const getTextWithNumberOfServices = (mainText: string, services: number) => {
    const replacedText = mainText.replace('${services}', `${services}`);
    return <span dangerouslySetInnerHTML={{ __html: replacedText }} />;
  };

  return (
    <AnalyticsProvider group="Service Notification">
      <Card background="success-bg-subtle" padding="small">
        <CardContent>
          <Grid align={['between-xs', 'middle-xs']} noWrap={['sm']}>
            <GridColumn width={['xs', 'max-sm']}>
              <Grid align={['middle-xs']}>
                {!isMobile && currentBreak !== 'md' && (
                  <GridColumn width={['min-xs']}>
                    <Icon size="md" modifiers={icon} />
                  </GridColumn>
                )}
                <GridColumn width={['min-xs']}>
                  <p className="h5">{getTextWithNumberOfServices(text, numberOfServices)}</p>
                </GridColumn>
              </Grid>
            </GridColumn>
            <GridColumn width={['max-xs', 'min-sm']}>
              <AnalyticsTrigger trigger={{ id: `Link - ${ctaUrl}`, callback: 'onClick' }}>
                <Button text={ctaText} iconRight="#arrow-right" block={isMobile} url={ctaUrl} />
              </AnalyticsTrigger>
            </GridColumn>
          </Grid>
        </CardContent>
      </Card>
      <Separator spacing="medium" color="invisible" />
    </AnalyticsProvider>
  );
});

export default ServiceNotification;
